import { computed } from 'vue';
import { useMetaProperties } from '@modules/discovery/composables';
import useSortableGrid from './useSortableGrid';
import { ComputedRef } from '../types/sortable-grid.definitions'; // eslint-disable-line no-unused-vars
/**
 *
 * @returns {ComputedRef<string>}
 */
export default function useGridCssClasses() {
  const { model } = useSortableGrid();
  const properties = useMetaProperties();

  const gridCssClasses = computed(() => {
    const { columnCount } = model?.value?.meta || {};
    return properties.value.fourColumnGridEnabled ? 'small-up-2 medium-up-3 large-up-4' : `small-up-2 medium-up-${columnCount || 4 } large-up-${columnCount || 4}`;
  });

  return gridCssClasses;
}
